import { AudienceEventConditionInput } from '@occc/graphql';
import {
  QualifiedEventsMemberPurchasedOperator,
  operatorToEventPurchaseConditionOperatorMap,
} from './constants';

export const getExcludeThresholdAndOperator = (
  operator: QualifiedEventsMemberPurchasedOperator,
) => {
  const excludeThresholdAndOperator: Pick<
    NonNullable<AudienceEventConditionInput['purchaseCondition']>,
    'excludeThreshold' | 'operator'
  > = {
    excludeThreshold: [
      QualifiedEventsMemberPurchasedOperator.MoreThan,
      QualifiedEventsMemberPurchasedOperator.LessThan,
    ].includes(operator),
    operator: operatorToEventPurchaseConditionOperatorMap[operator],
  };

  return excludeThresholdAndOperator;
};
